import { isString } from '@mbrtargeting/metatag-utils';

export interface Matcher<T> {
    regex: RegExp,
    extract: (match: RegExpMatchArray) => T,
}

export interface WaitForPostMessageOptions {
    /** will execute callback only once, afterward remove it */
    once?: boolean;
    /** waitForPostMessage will stop listening when AbortSignal is triggered */
    signal?: AbortSignal;
}

export const waitForPostMessage = <DATA>({ regex, extract }: Matcher<DATA>, callback: (data: DATA) => void, { once, signal }: WaitForPostMessageOptions = {}) => {
    const handler = ({ data }: MessageEvent<unknown>): void => {
        if (!isString(data)) return;
        const match = data.match(regex);
        if (!match) return;
        if (once) cancel();
        callback(extract(match));
    };
    const cancel = () => window.removeEventListener('message', handler);
    window.addEventListener('message', handler, { signal }); // not passing once here as ANY postMessage would cancel the event listener
    return {
        cancel,
    };
};
